import { render, staticRenderFns } from "./Tiktok.vue?vue&type=template&id=725c4a9c&scoped=true&"
import script from "./Tiktok.vue?vue&type=script&lang=js&"
export * from "./Tiktok.vue?vue&type=script&lang=js&"
import style0 from "./Tiktok.vue?vue&type=style&index=0&id=725c4a9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725c4a9c",
  null
  
)

export default component.exports